<template>
  <section class="hero">
    <h1 class="hero__header">
      <img :src="require('@/assets/img/caredo-logo.svg')" alt="Caredo" />
    </h1>
    <div class="hero__content">
      <p
        class="hero__title"
        v-html="
          `Pracujesz w firmie,<br> w której dochodzi do częstego przekazywania
          lub&nbsp;odbierania samochodów?`"
      ></p>
      <p
        class="hero__callout"
        v-html="`Takiej jak salon dealerski, serwis<br>czy wypożyczalnia samochodów?`"
      ></p>
    </div>
  </section>
</template>

<script>
export default {
  // eslint-disable-next-line quotes
  name: "hero",
};
</script>

<style lang="scss" scoped>
.hero {
  background: url("~@/assets/img/hero.png") center / cover no-repeat;
  height: 767px;
  padding: 80px 7.3vw;
  position: relative;

  @media screen and (min-width: 1920px) {
    padding: 80px 140px;
  }

  @media screen and (max-width: 1400px) {
    background-position: center right -200px;
  }

  @media screen and (max-width: 1100px) {
    height: 69.73vw;
    padding: 7.27vw 7.3vw;
  }

  @media screen and (max-width: 700px) {
    background-position: top right -100px;
    background-size: 180vw auto;
    height: auto;
  }
}

.hero__header {
  @media screen and (max-width: 700px) {
    height: 100%;
    img{
      width: 60%;
    }
  }
}

.hero__content {
  max-width: 600px;
  margin: 210px 3.13vw 0;

  @media screen and (min-width: 1920px) {
    margin: 210px 60px;
  }

  @media screen and (max-width: 1100px) {
    margin: 19.09vw 3.13vw;
  }

  @media screen and (max-width: 900px) {
    margin-top: 10vw;
    max-width: 500px;
  }

  @media screen and (max-width: 700px) {
    background-color: $bg-secondary;
    margin: 50% -7.3vw -7.27vw;
    max-width: none;
    padding: 40px 10vw;
    width: 100vw;

  }
}
.hero__title {
    font-family: AXIS,sans;
    font-size: 2.25em;
    line-height: 1.278em;
    margin: 0 0 40px;
    text-transform: uppercase;
     @media screen and (max-width: 750px) {
     font-size: 1em;
  }
}
.hero__callout {
  font-size: 1.45em;
  line-height: 1.5em;
  font-family: Lato, sans;
  // margin: 0 0 40px;
  @media screen and (max-width: 900px) {
    font-size: 1em;
    margin-bottom: 10px;
  }
  @media screen and (max-width: 750px) {
    margin-top: -20px;
  }
}

</style>
